import React, { useState } from 'react';
import { AnimatePresence } from 'framer-motion';
import { wrap } from 'popmotion';
import {
  variants,
  swipeConfidenceThreshold,
  swipePower,
} from 'constants/sliders';
import * as S from './styles';
import { Clothes } from 'contracts/Clothes';

interface Props {
  clothes: Clothes[];
}
const Gallery: React.FC<Props> = ({ clothes }) => {
  const [[page, direction], setPage] = useState([0, 0]);

  const indexSlide = wrap(0, clothes.length, page);
  const paginate = (newDirection: number) => {
    setPage([page + newDirection, newDirection]);
  };

  return (
    <S.Container>
      <S.Wrapper>
        <S.Frame>
          <AnimatePresence initial={false} custom={direction}>
            <S.Slide
              key={page}
              custom={direction}
              variants={variants}
              initial="enter"
              animate="center"
              exit="exit"
              transition={{
                x: { type: 'spring', stiffness: 300, damping: 30 },
                opacity: { duration: 0.2 },
              }}
              drag="x"
              dragConstraints={{ left: 0, right: 0 }}
              dragElastic={0}
              onDragEnd={(e, { offset, velocity }) => {
                const swipe = swipePower(offset.x, velocity.x);

                if (swipe < -swipeConfidenceThreshold) {
                  paginate(1);
                } else if (swipe > swipeConfidenceThreshold) {
                  paginate(-1);
                }
              }}
            >
              <img
                src={clothes[indexSlide].image}
                alt={clothes[indexSlide].name}
              />
            </S.Slide>
          </AnimatePresence>
        </S.Frame>
        <S.Actions>
          <S.LeftButton onClick={() => paginate(-1)}>
            <S.ArrowLeftIcon />
          </S.LeftButton>
          <S.RightButton onClick={() => paginate(1)}>
            <S.ArrowRightIcon />
          </S.RightButton>
        </S.Actions>
      </S.Wrapper>
      <S.BoxBuy>
        <S.BoxBuyTitle>{clothes[indexSlide].name}</S.BoxBuyTitle>
        <S.BoxBuyPrice>{clothes[indexSlide].price}</S.BoxBuyPrice>
        <S.BoxBuyButton
          onClick={() => window.open(clothes[indexSlide].url, '_blank')}
        >
          Comprar
        </S.BoxBuyButton>
      </S.BoxBuy>
    </S.Container>
  );
};

export default Gallery;
